import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-container">
        <header className="privacy-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </header>

        <div className="privacy-content">

          <section>
            <h2>1. Information We Collect</h2>
            <p>We collect only the information you voluntarily provide, such as your name, contact details, and service provider recommendations.</p>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use your information solely to operate and improve the hyve extension and related services, process recommendations, and respond to user inquiries.</p>
          </section>

          <section>
            <h2>3. Information Sharing</h2>
            <p>We do not sell or share your personal information except as required by law or with your consent.</p>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>We implement reasonable administrative, technical, and physical safeguards to protect your personal data from unauthorized access, use, or disclosure.</p>
          </section>

          <section>
            <h2>5. Children's Privacy</h2>
            <p>This extension is not intended for children under the age of 13. We do not knowingly collect personal data from children. Hyve has zero tolerance for CSAE. We: 1) Prohibit any content involving minors in inappropriate contexts, 2) Use automated and manual content moderation, 3) Require users to be 13+ years old, 4) Provide reporting tools for suspicious Content</p>
          </section>

          <section>
            <h2>6. Changes to This Policy</h2>
            <p>We may update this policy occasionally. If we make significant changes, we will notify you by updating the "Last updated" date and posting the revised policy here.</p>
          </section>

          <section>
            <h2>7. Contact Us</h2>
            <p>If you have questions, contact us at triedandtrusteddev@gmail.com.</p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
